function mapAchievementsFromSheet(payload) {
  //console.log("Mapping Achievements from Sheet Payload:", payload);

  let mappedAchievements = payload.map((item) => {
    return {
      uid: item.uid,
      name: item.term,
      description: item.definition,
      icon: item.image,
      points: item.meta1,
      category: item.category,
      targetScore: item.meta2,
      codes: item.meta4,
      status: item.status // approve/under review
    };
  });

  //console.log("Mapped Achievements:", mappedAchievements);

  return mappedAchievements;
}

function mapQuestionsFromSheet(payload) {
  //console.log("Mapping Questions from Sheet Payload:", payload);
  let mappedQuestions = payload.map((item) => {
    return {
      uid: item.uid,
      question: item.term,
      answer1: item.meta1,
      answer2: item.meta2,
      answer3: item.meta3,
      answer4: item.meta4,
      category: item.category
    };
  });

  return mappedQuestions;
}

function mapAwardedGroupPoints(payload) {
  //console.log("Mapping Awarded Group Points from Sheet Payload:", payload);

  let mappedPoints = payload.map((item) => {
    return {
      name: item.term,
      points: parseInt(item.meta1),
      reason: item.meta2,
      tsLastUpdated: item.ts_created
    };
  });

  return mappedPoints;
}

export {
  mapAchievementsFromSheet,
  mapQuestionsFromSheet,
  mapAwardedGroupPoints
};
